const types = {
	//Get Template name
	GET_ORGANIZATIONPROFILEFORMLIST_START: "GET_ORGANIZATIONPROFILEFORMLIST_START",
	GET_ORGANIZATIONPROFILEFORMLIST_SUCCESS: "GET_ORGANIZATIONPROFILEFORMLIST_SUCCESS",
	GET_ORGANIZATIONPROFILEFORMLIST_ERROR: "GET_ORGANIZATIONPROFILEFORMLIST_ERROR",
	GET_ORGANIZATIONPROFILEFORMLIST_RESET: "GET_ORGANIZATIONPROFILEFORMLIST_RESET",

	//single item  name
	SELECT_TOUPDATE_ITEM: "SELECT_TOUPDATE_ITEM",
};

export default types;
